/**
 * HELPER 
 * AgentHelper 
 * @method getId 
 * @method getUserOrganizations
 * @method getPermissionValueById
 * @method getPermissionValueById
*/
var AgentHelper = (function () {
    // var builder = new SumoPredicateBuilder();
    function AgentHelperInstance(){
        this.builder = new SumoPredicateBuilder();
    }
    /**
     * This method will get a list of Agents filtered by OrganizationId 
     * @param  {} lOrganizationId
     */
    AgentHelperInstance.prototype.getId = function(lOrganizationId){
        this.builder.Clear();
        this.builder.AddNewExpressionConditional('DisplayType', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        if(lOrganizationId){
            this.builder.AddNewExpressionConditional('OrganizationId', lOrganizationId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        }
        this.builder.AddNewExpressionConditional('UserId', gUserDetails.UserId, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        var lMyAgents = query(getDataItems('Agents'), this.builder.RootExpression);
        var AgentID = null;
        if (lMyAgents.length > 0) {
            for (lKey in lMyAgents) {
                AgentID = lMyAgents[lKey].Id
                break;
            }
        }
        if(AgentID === null || !AgentID){
            return gUserDetails.UserId
        }
        return AgentID;
    };
    /**
     * This Method will retrieve the Agent List filter by a Given Attribute  
     * @param  {} aAttribute
     * @param  {} aValue
     * e.g. 
     * var agents= AgentHelper.getBy('OrganizationId',1234); 
     */
    AgentHelperInstance.prototype.getBy = function(aAttribute,aValue){
        this.builder.Clear();
        this.builder.AddNewExpressionConditional('DisplayType', 1, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        this.builder.AddNewExpressionConditional(aAttribute, aValue, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        return query(getDataItems('Agents'), this.builder.RootExpression);
    };
    /**
     * This method will get the Organization List from the current User.
     */
    AgentHelperInstance.prototype.getUserOrganizations = function(){
        this.builder.Clear();
        this.builder.AddNewExpressionConditional('Id', gUserDetails.OrganizationIds, false, mRelationalOperatorEnum.In(), mLogicalOperatorEnum.And());
        return query(OrganizationSortFormatter(), this.builder.RootExpression);
    };
    /**
     * This method will get the list of permission value by a given permission Id
     * @param  {} Id
     * @returns {number} will return 0 if value is not found. 
     */
    AgentHelperInstance.prototype.getPermissionValueById = function(Id){
        this.builder.Clear();
        this.builder.AddNewExpressionConditional('PermissionId', Id, false, mRelationalOperatorEnum.Equal(), mLogicalOperatorEnum.And());
        var permission = query(gUserPermissions, this.builder.RootExpression);
        return permission[Id]? permission[Id]['Value'] : 0;
    };
    return new AgentHelperInstance();
})();

if (typeof exports !== 'undefined') {
    module.exports = AgentHelper;
}